// extracted by mini-css-extract-plugin
module.exports = {"grid":"ProductGrid_grid__Y78Lv"};